import { defineMessages } from 'react-intl';

export default defineMessages({
  noPendingRefunds: {
    id: 'RefundsList.noPendingRefunds',
    defaultMessage: 'Hurray, no pending refunds in this list!',
  },
});
